import { memo } from "react";
import { Text } from "../../text";
import { TextColorValue, TextSizeValue } from "../../theme/typography";
import * as descriptorCss from "./descriptors.module.css";

export type DescriptorSize = Omit<TextSizeValue, "xxs">;

export const LabelText = memo(function LabelText({
  label,
  size = "sm",
  disabled,
  htmlFor,
}: {
  label?: string;
  size?: TextSizeValue;
  disabled?: boolean;
  /** When set, renders the text as a `<label>` connected to this input id. */
  htmlFor?: string;
}) {
  if (!label) {
    return null;
  }

  const labelTextColor: TextColorValue =
    (disabled && "disabled") || "secondary";

  return (
    <Text
      as="label"
      className={descriptorCss.text}
      fontSize={size}
      fontWeight="medium"
      htmlFor={htmlFor}
      textColor={labelTextColor}
    >
      {label}
    </Text>
  );
});

export const DescriptionText = memo(function DescriptionText({
  description,
  size = "sm",
  error,
  disabled,
}: {
  description?: string;
  size?: TextSizeValue;
  error?: boolean;
  disabled?: boolean;
}) {
  if (!description) {
    return null;
  }

  const descriptionTextColor: TextColorValue =
    (disabled && "disabled") || (error && "error") || "secondary";

  return (
    <Text
      className={descriptorCss.text}
      fontSize={size}
      fontWeight="regular"
      textColor={descriptionTextColor}
    >
      {description}
    </Text>
  );
});

export const ErrorText = memo(function ErrorText({
  text,
  size = "sm",
}: {
  text?: string;
  size?: TextSizeValue;
}) {
  if (!text) {
    return null;
  }

  return (
    <Text fontSize={size} fontWeight="regular" textColor="error">
      {text}
    </Text>
  );
});
